import { BugIcon, CircleXIcon, InfoIcon, OctagonAlertIcon, TriangleAlertIcon, type LucideIcon } from 'lucide-react';
import type { BadgeVariant } from '@/shared/components/Badge';
import type { ServerLogLevel } from '@/shared/types/api';

/**
 * Presentation for server-log levels, in the classificationMeta shape: one record, a fallback
 * for a level name the server adds later, and a getter that never returns undefined.
 * Colors come from the Badge variants, so both themes are correct by construction.
 */
export interface LogLevelMeta {
  label: string;
  badge: BadgeVariant;
  icon: LucideIcon;
}

export const logLevelFallback: LogLevelMeta = {
  label: 'Unknown',
  badge: 'neutral',
  icon: InfoIcon,
};

export const logLevelMeta: Record<ServerLogLevel, LogLevelMeta> = {
  Fatal: { label: 'Fatal', badge: 'danger', icon: OctagonAlertIcon },
  Error: { label: 'Error', badge: 'danger', icon: CircleXIcon },
  Warning: { label: 'Warning', badge: 'warning', icon: TriangleAlertIcon },
  Information: { label: 'Info', badge: 'info', icon: InfoIcon },
  Debug: { label: 'Debug', badge: 'neutral', icon: BugIcon },
  Verbose: { label: 'Verbose', badge: 'neutral', icon: BugIcon },
};

export const getLogLevelMeta = (v?: ServerLogLevel | string | null): LogLevelMeta =>
  (v && logLevelMeta[v as ServerLogLevel]) || logLevelFallback;
